import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import FooterSection from './FooterSection';

const API_BASE_URL = 'https://care-api.equily.ng';

const formatDate = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

function Blog() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const controller = new AbortController();

    const fetchBlogs = async () => {
      try {
        setLoading(true);
        setError('');

        const response = await fetch(`${API_BASE_URL}/api/blogs`, {
          signal: controller.signal,
        });

        if (!response.ok) {
          throw new Error('Unable to fetch blogs at the moment.');
        }

        const result = await response.json();
        setBlogs(Array.isArray(result?.data) ? result.data : []);
      } catch (err) {
        if (err.name !== 'AbortError') {
          setError(err.message || 'Something went wrong while fetching blogs.');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();

    return () => controller.abort();
  }, []);

  return (
    <>
      <section className='bg-white min-h-screen py-12 px-4 sm:px-8 md:px-20'>
        <div className='max-w-6xl mx-auto'>
          <div className='mb-10'>
            <h1 className='text-3xl sm:text-4xl font-Anton text-orange-900'>
              Blog Posts
            </h1>
            <p className='font-raleway text-gray-600 mt-2'>
              Latest updates from CARE Nigeria.
            </p>
          </div>

          {loading && (
            <p className='font-raleway text-gray-600'>Loading blogs...</p>
          )}

          {!loading && error && (
            <p className='font-raleway text-red-600'>{error}</p>
          )}

          {!loading && !error && blogs.length === 0 && (
            <p className='font-raleway text-gray-600'>No blog posts available.</p>
          )}

          {!loading && !error && blogs.length > 0 && (
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'>
              {blogs.map((blog) => {
                const routeParam = blog.id || blog.id;
                return (
                  <article
                    key={blog.id}
                    className='bg-gray-100 rounded-lg shadow-sm overflow-hidden flex flex-col'
                  >
                    {blog.file_url && (
                      <img
                        src={blog.file_url}
                        alt={blog.title || 'Blog'}
                        className='w-full h-52 object-cover'
                      />
                    )}

                    <div className='p-5 flex-1 flex flex-col'>
                      <p className='text-sm font-raleway text-gray-500 mb-2'>
                        {formatDate(blog.published_at || blog.created_at)}
                      </p>

                      <h2 className='text-xl font-raleway font-semibold text-orange-900 mb-3'>
                        {blog.title}
                      </h2>

                      <p className='font-raleway text-gray-700 mb-5 flex-1'>
                        {blog.excerpt || 'Read this blog post for more details.'}
                      </p>

                      <Link
                        to={`/blog/${routeParam}`}
                        className='inline-flex items-center justify-center bg-orange-500 hover:bg-orange-600 text-white font-raleway text-sm px-4 py-2 rounded-md w-fit'
                      >
                        Read More
                      </Link>
                    </div>
                  </article>
                );
              })}
            </div>
          )}
        </div>
      </section>
      <FooterSection />
    </>
  );
}

export default Blog;
